/* eslint-disable camelcase */

import { makeAutoObservable, set, toJS } from 'mobx'

class RolesAction {
  id = 0
  role_id = 0
  controller = ''
  read_all = false
  read_limited = false
  read_owner = false
  create = false
  edit = false
  delete = false

  _fieldToSave = [
    'id',
    'controller',
    'read_all',
    'read_limited',
    'read_owner',
    'create',
    'edit',
    'delete'
  ]

  constructor (data) {
    makeAutoObservable(this)
    if (data) {
      set(this, data)
    }
  }

  toJson () {
    const rolesAction = {}
    for (const props of this._fieldToSave) {
      rolesAction[props] = toJS(this[props])
    }
    return rolesAction
  }
}

export default RolesAction
